<template>
    <div :class="['popup-container container-fluid', show ? 'open' : '']">
        <div class="row">
            <div class="popup col-12 col-md-8 p-5">
                <div class="popup-close" @click="close">
                    <icon type="close"/>
                </div>
                <div class="popup-content">
                    <slot name="popupMainContent"/>
                    <div class="popup-content-footer">
                        <slot name="popupFooter"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from "./Icon";

    export default {
        name: "Popup",
        components: {
            Icon,
        },
        props: {
            show: {type: Boolean, default: true},
        },
        methods: {
            close: function () {
                this.$emit('close');
            },
        },

    }
</script>

<style lang="scss" scoped>
    .popup-container {
        background-color: rgba(0, 0, 0, 0.8);
        position: fixed;
        width: 0;
        height: 0;
        overflow: hidden;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 10000;

        &.open {
            width: 100vw;
            height: 100vh;
        }
    }

    .popup {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        background-color: #404344;
        max-height: 100vh;
        overflow: auto;
    }

    .popup-close {
        position: absolute;
        top: 15px;
        right: 15px;
        font-size: 1.4em;
        color: #fff;
        cursor: pointer;
    }
</style>